import Main from './main';
import GeneralUtility from './utilities/general-utility';
import UserSettings from './utilities/user-settings';
import FormHelpers from './components/form-helpers';
import LanguageUtility from './utilities/language-utility';
import ScrollPosition from '../types/scroll-position';

document.addEventListener('DOMContentLoaded', () => {
    // Setup global resize events
    let orientation = GeneralUtility.getDeviceOrientation();
    document.body.classList.add(orientation);
    let previousOrientation: string = '';

    window.addEventListener('resize', () => {
        GeneralUtility.browserEmitter.emit('resize', GeneralUtility.getWindowDimensions());

        // Update device orientation
        orientation = GeneralUtility.getDeviceOrientation();
        if (orientation !== previousOrientation) {
            if (previousOrientation) {
                document.body.classList.remove(previousOrientation);
            }

            if (orientation) {
                document.body.classList.add(orientation);
                GeneralUtility.browserEmitter.emit('orientation', orientation);
            }
        }

        previousOrientation = orientation;
    }, {'capture': false, 'passive': true});

    // Setup global scroll events
    let previousScrollY = 0;
    let previousScrollX = 0;
    window.addEventListener('scroll', () => {
        const scrollY = window.scrollY;
        const scrollX = window.scrollX;
        const scrollPosition: ScrollPosition = {
            'previousScrollY': previousScrollY,
            'scrollY': scrollY,
            'previousScrollX': previousScrollX,
            'scrollX': scrollX
        };

        GeneralUtility.browserEmitter.emit('scroll', scrollPosition);
        previousScrollY = scrollY;
        previousScrollX = scrollX;
    }, {'capture': false, 'passive': true});

    // Check if there are any unsaved forms, before leaving the page
    FormHelpers.initializeUnsavedFormsCheck();
    window.addEventListener('beforeunload', e => {
        if (FormHelpers.checkIfUnsavedFormsPresent()) {
            const confirmationMessage = LanguageUtility.getLabel('formsChanged');
            (e || window.event).returnValue = confirmationMessage;
            return confirmationMessage;
        } else {
            return undefined;
        }
    });

    // Initialize main class
    new Main();
});

window.addEventListener('beforeunload', () => {
    const now = Math.floor((new Date()).getTime() / 1000);
    const settingsTimestamp = Math.floor(UserSettings.getInstance().get().timestamp / 1000);

    // Reset settings after 1 hour
    if (settingsTimestamp < now - (1 * 60 * 60)) {
        UserSettings.getInstance().reset();
    }
});
